import React from 'react';

import { CoinRace } from '@entities/coin-race';

const CoinRacePage = () => {
	return <CoinRace />;
};

export default CoinRacePage;
